const pixelsCategories = ["PERFORMANCE","SOCIAL","TARGETING","STRICTLY_NECESSARY"];

export { pixelsCategories };